import { LUIGI_DELETED_STATUS, isAppModule } from '@src/utils/constants';
import { useCallback, useEffect } from 'react';
import { useSetAtom, useAtomValue } from 'jotai';
import { errorResponseAtom } from '@src/components/metrics-panel-hz/atoms/index';
import { useSelector } from 'react-redux';
import { realTimeModeOnTrendsSelector } from '@src/store/common/selectors';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { cloneDeep } from 'lodash';

export const useResetError = () => {
  const setErrorResponse = useSetAtom(errorResponseAtom);
  return useCallback(() => {
    if (errorData.shouldBeReset) {
      setErrorResponse({});
      resetErrorData();
    }
  }, [setErrorResponse]);
};

export const useSetError = () => {
  const setErrorResponse = useSetAtom(errorResponseAtom);
  const realTimeOnTrends = useSelector(realTimeModeOnTrendsSelector);

  const { dataScope, usecaseKey } = useSelector(activeDashboardSelector);

  const handleError = useCallback(
    (event) => {
      const response = event.detail.data;
      const isPresetError = isAppModule && !!response?.presetKey;
      const { error } = makeErrorData(response, !realTimeOnTrends && !isPresetError, {
        shouldBeReset: isPresetError,
      });
      setErrorResponse(error);
    },
    [realTimeOnTrends, usecaseKey, dataScope],
  );

  useEffect(() => {
    document.addEventListener('LUIGI_DELTED_STATUS', handleError);
    return () => {
      document.removeEventListener('LUIGI_DELTED_STATUS', handleError);
    };
  }, [handleError, usecaseKey]);
};

export let errorData = {
  shouldBeReset: false,
  fields: [],
  filters: [],
};

const makeErrorData = (data, mergePrevError, options = { shouldBeReset: false }) => {
  const { shouldBeReset } = options;
  const error: any = mergePrevError ? cloneDeep(errorData) : { fields: [], filters: [] };
  error.shouldBeReset = shouldBeReset;
  if (data.code === LUIGI_DELETED_STATUS) {
    data.error.fields.forEach((f) => {
      const field = f.split('.')[1];
      error[field] = true;
    });
    data.error.filters.forEach((f) => {
      const field = f.split('.')[1];
      error[field] = true;
    });
    error['fields'] = [...error.fields, ...data.error.fields];
    error['filters'] = [...error.filters, ...data.error.filters];
  }
  errorData = error;
  return { error };
};

const resetErrorData = () => {
  errorData = {
    shouldBeReset: false,
    fields: [],
    filters: [],
  };
};

export const doesFilterContainsInvalidField = (appliedFilter) => {
  let filterError = false;
  appliedFilter.rule.forEach((rule) => {
    rule.forEach((r) => {
      if (errorData[r.field] === true) filterError = true;
    });
  });
  return filterError;
};
